import { render, staticRenderFns } from "./CheckoutSection.vue?vue&type=template&id=b9e30c1a&"
import script from "./CheckoutSection.vue?vue&type=script&lang=js&"
export * from "./CheckoutSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports